const getFormattedDate = date => (date ? new Date(date).toISOString().slice(0, 10) : null)

export default getFormattedDate
